import Container from '../Layout/container';

const CountdownSkeleton: React.FC<{ style?: Record<string, string> }> = ({ style }) => {
  return (
    <Container>
      <div className="py-5 w-full mx-auto bg-surface-200-bg" style={style}></div>
    </Container>
  );
};

export default CountdownSkeleton;
